import React, {Component} from 'react';
import {injectIntl, intlShape} from 'react-intl';
import {Link} from 'react-router';
import PropTypes from 'prop-types';

import {sendToParent, TYPES} from '../../common/events';
import AppBlock from '../components/AppBlock';
import Title from '../components/Form/Title';

const clickEventListener = function(event) {
  if (event.target.nodeName.toUpperCase() === 'BODY') {
    sendToParent(TYPES.HIDE_POPUP);
  }
};

class Page404 extends Component {
  // eslint-disable-next-line class-methods-use-this
  componentDidMount() {
    if (window.self === window.top) {
      document.body.classList.add('with-bg');
    }
    document.addEventListener('click', clickEventListener);
  }

  // eslint-disable-next-line class-methods-use-this
  componentWillUnmount() {
    document.removeEventListener('click', clickEventListener);
  }

  render() {
    const {
      intl: {messages},
      location
    } = this.props;

    return (
      <div className="content">
        <div className="wrapper">
          <AppBlock>
            <Title title={messages['page404.title']} titleClassName="title--error" />

            <div className="block-content block-content--horizontal-center">
              <span className="form-group">{messages['page404.text']}</span>

              <Link
                className="form-group form-button button-with-bg"
                to={{
                  pathname: '/',
                  search: location.search
                }}
              >
                {messages['page404.to-login']}
              </Link>
            </div>
          </AppBlock>
        </div>
      </div>
    );
  }
}

Page404.propTypes = {
  intl: intlShape,
  location: PropTypes.object.isRequired
};

export default injectIntl(Page404);



// WEBPACK FOOTER //
// ./pages/404.jsx